import React, { Component } from 'react';
import { GOOGLE_AUTH_URL, FACEBOOK_AUTH_URL, GITHUB_AUTH_URL, ACCESS_TOKEN } from '../../constatns';
import { Link, Redirect } from 'react-router-dom'
import fbLogo from '../../assets/img/fb-logo.png';
import googleLogo from '../../assets/img/google-logo.png';
import githubLogo from '../../assets/img/github-logo.png';
import Alert from 'react-s-alert';
import { login } from "../../util/api";
import queryString from 'querystring';

class Login extends Component {

	constructor(props) {
		super(props);
	}

	componentDidMount() {

		const param = queryString.parse((this.props.location.search).replace("?",""));
		if(param.email) localStorage.setItem("__EM__", param.email);
		if(param.id) localStorage.setItem("__ID__", param.id);
		if(param.token) {
			localStorage.setItem(ACCESS_TOKEN, param.token);
			window.location.href = "/";
		}

		if(this.props.location.state && this.props.location.state.error) {
			setTimeout(() => {
				Alert.error(this.props.location.state.error, {
					timeout: 5000
				});
				this.props.history.replace({
					pathname: this.props.location.pathname,
					state: {}
				});
			}, 100);
		}
	}

	render() {

		if(localStorage.getItem(ACCESS_TOKEN)) {
			return <Redirect
				to={{
					pathname: "/",
					state: { from: this.props.location }
				}}/>;
		}

		return (
			<div className="login-container">
				<div className="login-content">
					<h1 className="login-title">Login to HALASZ</h1>
					<SocialLogin />
					<div className="or-separator">
						<span className="or-text">OR</span>
					</div>
					<LoginForm {...this.props} />
					<span className="signup-link">New user? <Link to="/signup">Sign up!</Link></span>
				</div>
			</div>
		);
	}
}

class SocialLogin extends Component {
	render() {
		return (
			<div className="social-login">
				<a className="btn btn-block social-btn google" href={GOOGLE_AUTH_URL}>
					<img src={googleLogo} alt="Google" /> Log in with Google</a>
				<a className="btn btn-block social-btn facebook" href={FACEBOOK_AUTH_URL}>
					<img src={fbLogo} alt="Facebook" /> Log in with Facebook</a>
				<a className="btn btn-block social-btn github" href={GITHUB_AUTH_URL}>
					<img src={githubLogo} alt="Github" /> Log in with Github</a>
			</div>
		);
	}
}


class LoginForm extends Component {

	constructor(props) {
		super(props);

		this.state = {
			email: '',
			password: ''
		};
		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	handleInputChange(event) {
		const target = event.target;
		const inputName = target.name;
		const inputValue = target.value;

		this.setState({
			[inputName] : inputValue
		});
	}

	handleSubmit(event) {
		event.preventDefault();

		const loginRequest = Object.assign({}, this.state);
		login(loginRequest).then(response => {
			localStorage.setItem(ACCESS_TOKEN, response.accessToken);
			localStorage.setItem("__EM__", response.user.email);
			localStorage.setItem("__ID__", response.user.id);
			Alert.success("You're successfully logged in!");
			this.props.history.push("/");
		}).catch(error => {
			Alert.error('Incorrect email or password.');
		});
	}

	render() {
		return (
			<form onSubmit={this.handleSubmit}>
				<div className="form-item">
					<input type="email" name="email"
								 className="form-control" placeholder="Email"
								 value={this.state.email} onChange={this.handleInputChange} required/>
				</div>
				<div className="form-item">
					<input type="password" name="password"
								 className="form-control" placeholder="Password"
								 value={this.state.password} onChange={this.handleInputChange} required/>
				</div>
				<div className="form-item">
					<button type="submit" className="btn btn-block btn-primary">Login</button>
				</div>
			</form>
		);
	}
}

export default Login
